import React, { useState, useEffect } from "react";
import { getLpTable, getLpTableClear } from "../../redux/reports/actions";
import ContentDetailComponent from "./ContentDetailComponent";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { SessionKeys } from "../../utils/AppUtils";
import { is } from "immutable";
import { useTranslation } from "react-i18next";

const OBLPDetailComponent = ({ isOB, isOther, userId }) => {
  let dispatch = useDispatch();
  const { t } = useTranslation();
  const [profileReports, setProfileReports] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [profileFilterReports, setProfileFilterReports] = useState([]);
  const lpTableRes = useSelector((state) => state.report?.lpTable);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedBox, setSelectedBox] = useState("");

  const [stats, setStats] = useState({
    completed: 0,
    inprogress: 0,
    overdue: 0,
    notStarted: 0,
  });

  // const [series, setSeries] = useState([]);
  // const [labels, setLabels] = useState([
  //   "Completed",
  //   "In Progress",
  //   "Yet to Start",
  //   "Overdue",
  // ]);

  // const [colors, setColors] = useState([
  //   "#A9DBB8",
  //   "#f0a446",
  //   "#59564d",
  //   "#ff4560",
  // ]);

  const [sections, setSections] = useState([]);

  useEffect(() => {
    if (!_.isEmpty(lpTableRes)) {
      if (lpTableRes?.status === "success") {
        const reportData = lpTableRes?.payload?.payload?.user_data;
        let sections_data = [];
        stats.completed = reportData?.filter(
          (data) => _.toLower(data.profile_status) === "completed",
        ).length;

        stats.overdue = reportData?.filter(
          (data) =>
            _.toLower(data.profile_status) === "overdue" ||
            data.profile_status === "over-due",
        ).length;

        stats.notStarted = reportData?.filter(
          (data) =>
            data.profile_status === "not-started" ||
            _.toLower(data.profile_status) === "yet to start",
        ).length;

        stats.inprogress = reportData?.filter(
          (data) =>
            _.toLower(data.profile_status) === "in-progress" ||
            _.toLower(data.profile_status) === "inprogress" ||
            (data.profile_progress > 0 && data.profile_progress < 100),
        ).length;

        let total =
          stats.completed + stats.inprogress + stats.notStarted + stats.overdue;

        if (stats.completed > 0) {
          let per = (stats.completed / total) * 100;
          sections_data.push({
            value: per,
            color: "rgba(71, 196, 120, 1)",
            label: "Completed",
          });
        }

        if (stats.inprogress > 0) {
          let per = (stats.inprogress / total) * 100;
          sections_data.push({
            value: per,
            color: "rgba(240, 164, 70, 1)",
            label: "In Progress",
          });
        }
        if (stats.notStarted > 0) {
          let per = (stats.notStarted / total) * 100;
          sections_data.push({
            value: per,
            color: "rgba(144, 152, 154, 1)",
            label: "Yet to start",
          });
        }

        if (stats.overdue > 0) {
          let per = (stats.overdue / total) * 100;
          sections_data.push({
            value: per,
            color: "rgba(239, 103, 121, 1)",
            label: "Overdue",
          });
        }
        setSections(sections_data);
        const sortedData = _.sortBy(reportData, [
          (report) => report?.lp_name?.toLowerCase(),
        ]);
        const transformedArray = sortedData.map((item, index) => ({
          sl_no: index + 1,
          name: item.lp_name,
          status: item.profile_status,
          progress: item.profile_progress,
          source: item?.source,
          lp_id: item?.lp_id,
          course_status: item?.entity_status,
          is_disabled: item?.is_disabled,
        }));
        setProfileReports(transformedArray);
        setProfileFilterReports(transformedArray);
      } else {
        setProfileReports([]);
      }
      setIsLoading(false);
      dispatch(getLpTableClear());
    }
  }, [lpTableRes]);

  const OBLPDataReport = (reaId) => {
    dispatch(
      getLpTable({
        module: "getlPReportTable",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          limit: 1,
          rea_ids: reaId,
          entity_id: [],
          office_ids: [],
          provider_ids: [],
          is_onboarding: isOB ? 1 : 0,
          manager_ids: [],
          date_range: {
            start: "",
            end: "",
          },
          status: ["completed", "in-progress", "overdue", "not-started"],
          role: ["participant", "reporting_manager", "program_manager", "all"],
          isDownload: true,
          fetchDetail: false,
        },
      }),
    );
  };

  useEffect(() => {
    setSelectedBox("");
    let reaId = [];
    reaId.push(userId);
    setIsLoading(true);
    setSearchText("");
    setIsNameAsc(true);
    setIsStatusAsc("");
    setIsProgressAsc("");
    setSections([]);
    setStats({
      completed: 0,
      inprogress: 0,
      overdue: 0,
      notStarted: 0,
    });
    OBLPDataReport(reaId);
    return () => {
      dispatch(getLpTableClear());
    };
  }, [isOB]);

  const onSearchClicked = () => {
    setIsLoading(true);
    if (
      searchText === "" ||
      searchText === "undefined" ||
      searchText === null
    ) {
      statsCal(profileFilterReports);
      setProfileReports(profileFilterReports);
    } else {
      let searchedData = [];
      for (let item of profileFilterReports) {
        if (_.toLower(item?.name)?.includes(_.toLower(searchText))) {
          searchedData.push(item);
        }
      }
      statsCal(searchedData);
      setProfileReports(searchedData);
    }
    setIsLoading(false);
  };

  const statsCal = (searchedData) => {
    let sections_data = [];
    stats.completed = searchedData?.filter(
      (data) => _.toLower(data.status) === "completed",
    ).length;

    stats.overdue = searchedData?.filter(
      (data) =>
        _.toLower(data.status) === "overdue" || data.status === "over-due",
    ).length;

    stats.notStarted = searchedData?.filter(
      (data) =>
        _.toLower(data.status) === "not-started" ||
        _.toLower(data.status) === "yet to start",
    ).length;

    stats.inprogress = searchedData?.filter(
      (data) =>
        _.toLower(data.status) === "in-progress" ||
        _.toLower(data.status) === "inprogress" ||
        (data.progress > 0 && data.progress < 100),
    ).length;

    let total =
      stats.completed + stats.inprogress + stats.notStarted + stats.overdue;

    if (stats.completed > 0) {
      let per = (stats.completed / total) * 100;
      sections_data.push({
        value: per,
        color: "rgba(71, 196, 120, 1)",
        label: "Completed",
      });
    }

    if (stats.inprogress > 0) {
      let per = (stats.inprogress / total) * 100;
      sections_data.push({
        value: per,
        color: "rgba(240, 164, 70, 1)",
        label: "In Progress",
      });
    }
    if (stats.notStarted > 0) {
      let per = (stats.notStarted / total) * 100;
      sections_data.push({
        value: per,
        color: "rgba(144, 152, 154, 1)",
        label: "Yet to start",
      });
    }

    if (stats.overdue > 0) {
      let per = (stats.overdue / total) * 100;
      sections_data.push({
        value: per,
        color: "rgba(239, 103, 121, 1)",
        label: "Overdue",
      });
    }
    setSections(sections_data);
  };

  const [isNameAsc, setIsNameAsc] = useState(true);
  const [isProgressAsc, setIsProgressAsc] = useState("");
  const [isStatusAsc, setIsStatusAsc] = useState("");

  const setNameOrder = () => {
    setIsNameAsc(!isNameAsc);
  };

  useEffect(() => {
    console.log("course data isCourseAsc", isNameAsc);
    if (isNameAsc) {
      const sortedData = _.orderBy(
        profileReports,
        [(report) => report?.name?.toLowerCase()],
        "asc",
      );
      console.log("course data asc", sortedData);
      const transformedArray = sortedData.map((item, index) => ({
        sl_no: index + 1,
        name: item.name,
        status: item.status,
        progress: item.progress,
        source: item?.source,
        lp_id: item?.lp_id,
        course_status: item?.entity_status,
        is_disabled: item?.is_disabled,
      }));
      setProfileReports(transformedArray);
    } else {
      const sortedData = _.orderBy(
        profileReports,
        [(report) => report?.name?.toLowerCase()],
        "desc",
      );
      console.log("course data desc", sortedData);
      const transformedArray = sortedData.map((item, index) => ({
        sl_no: index + 1,
        name: item.name,
        status: item.status,
        progress: item.progress,
        source: item?.source,
        lp_id: item?.lp_id,
        course_status: item?.entity_status,
        is_disabled: item?.is_disabled,
      }));
      setProfileReports(transformedArray);
    }
  }, [isNameAsc]);

  const setProgressOrder = () => {
    if (isProgressAsc === "") {
      setIsProgressAsc(true);
    } else {
      setIsProgressAsc(!isProgressAsc);
    }
  };

  useEffect(() => {
    for (const item of profileReports) {
      item.progress = Number(item.progress);
    }
    console.log("progress data ", profileReports);
    if (isProgressAsc) {
      const sortedData = _.orderBy(profileReports, "progress", "asc");
      console.log("progress data asc", sortedData);
      const transformedArray = sortedData.map((item, index) => ({
        sl_no: index + 1,
        name: item.name,
        status: item.status,
        progress: item.progress,
        source: item?.source,
        lp_id: item?.lp_id,
        course_status: item?.entity_status,
        is_disabled: item?.is_disabled,
      }));
      setProfileReports(transformedArray);
    } else {
      const sortedData = _.orderBy(profileReports, "progress", "desc");
      console.log("progress data desc", sortedData);
      const transformedArray = sortedData.map((item, index) => ({
        sl_no: index + 1,
        name: item.name,
        status: item.status,
        progress: item.progress,
        source: item?.source,
        lp_id: item?.lp_id,
        course_status: item?.entity_status,
        is_disabled: item?.is_disabled,
      }));
      setProfileReports(transformedArray);
    }
  }, [isProgressAsc]);

  const setStatusOrder = () => {
    if (isStatusAsc === "") {
      setIsStatusAsc(true);
    } else {
      setIsStatusAsc(!isStatusAsc);
    }
  };

  useEffect(() => {
    console.log("status data ", isStatusAsc);
    if (isStatusAsc) {
      const sortedData = _.orderBy(
        profileReports,
        [(report) => report?.status?.toLowerCase()],
        "asc",
      );
      console.log("progress data asc", sortedData);
      const transformedArray = sortedData.map((item, index) => ({
        sl_no: index + 1,
        name: item.name,
        status: item.status,
        progress: item.progress,
        source: item?.source,
        lp_id: item?.lp_id,
        course_status: item?.entity_status,
        is_disabled: item?.is_disabled,
      }));
      setProfileReports(transformedArray);
    } else {
      const sortedData = _.orderBy(
        profileReports,
        [(report) => report?.status?.toLowerCase()],
        "desc",
      );
      console.log("progress data desc", sortedData);
      const transformedArray = sortedData.map((item, index) => ({
        sl_no: index + 1,
        name: item.name,
        status: item.status,
        progress: item.progress,
        source: item?.source,
        lp_id: item?.lp_id,
        course_status: item?.entity_status,
        is_disabled: item?.is_disabled,
      }));
      setProfileReports(transformedArray);
    }
  }, [isStatusAsc]);

  useEffect(() => {
    if (!_.isEmpty(selectedBox)) {
      setProfileReports([]);
      setIsLoading(true);
      console.log("selected box---", selectedBox);
      let searchedData = [];
      if (selectedBox === "all") {
        setProfileReports(profileFilterReports);
      } else {
        if (selectedBox === "completed") {
          searchedData.push(
            profileFilterReports?.filter(
              (data) => _.toLower(data.status) === "completed",
            ),
          );
          console.log("selected box---searched data---", searchedData);
        }

        if (selectedBox === "yt-start") {
          searchedData.push(
            profileFilterReports?.filter(
              (data) =>
                _.toLower(data.status) === "not-started" ||
                _.toLower(data.status) === "yet to start",
            ),
          );
        }

        if (selectedBox === "inprogress") {
          searchedData.push(
            profileFilterReports?.filter(
              (data) =>
                _.toLower(data.status) === "in-progress" ||
                _.toLower(data.status) === "inprogress" ||
                (data?.progress > 0 && data?.progress < 100),
            ),
          );
        }
        if (selectedBox === "overdue") {
          searchedData.push(
            profileFilterReports?.filter(
              (data) =>
                _.toLower(data.status) === "overdue" ||
                data.status === "over-due",
            ),
          );
        }
        setProfileReports(searchedData[0]);
      }

      // statsCal(searchedData);

      setIsLoading(false);
    }
  }, [selectedBox]);

  return (
    <>
      <ContentDetailComponent
        isLoading={isLoading}
        stats={stats}
        profileReports={profileReports}
        heading={isOB ? "Onboardings" : t("action_paths")}
        onSearchClicked={onSearchClicked}
        searchText={searchText}
        setSearchText={setSearchText}
        sections={sections}
        isNameAsc={isNameAsc}
        setNameOrder={setNameOrder}
        isProgressAsc={isProgressAsc}
        setProgressOrder={setProgressOrder}
        isStatusAsc={isStatusAsc}
        setStatusOrder={setStatusOrder}
        selectedBox={selectedBox}
        setSelectedBox={setSelectedBox}
        isOther={isOther}
      />
    </>
  );
};

export default OBLPDetailComponent;
